import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Box, TextField, Button, FormLabel, Typography } from '@mui/material';
import { goalMappings, convertGenderText } from '../utils/consts';

const EcologySection = ({ onNext, formData }) => {
    // We only need one form field for the current answer.
    const { control, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        defaultValues: { currentAnswer: '' }
    });

    const completedGoal = goalMappings[formData.cel_wybor]?.completed || formData.cel_wybor;

    const everdayLife = (goal) => {
        switch (goal) {
            case "Szukam pierwszej pracy":
                return `Wyobraź sobie, że ${convertGenderText('znalazłeś/aś', formData.zwrot_plec)} pierwszą pracę, jak teraz wygląda Twoją codzienność?`;
            case "Szukam pracy":
                return `Wyobraź sobie, że ${convertGenderText('znalazłeś/aś', formData.zwrot_plec)} pracę, jak teraz wygląda Twoją codzienność?`;
            case "Myślę o znalezieniu innej/nowej pracy":
                return `Wyobraź sobie, że ${convertGenderText('podjąłeś/łaś', formData.zwrot_plec)} decyzję o szukaniu innej pracy, jak teraz wygląda Twoją codzienność?`;
            case "Wracam na rynek pracy":
                return `Wyobraź sobie, że ${convertGenderText('wróciłeś/aś', formData.zwrot_plec)} na rynek pracy, jak teraz wygląda Twoją codzienność?`;
            case "Przekwalifikowuje się":
                return `Wyobraź sobie, że ${convertGenderText('przekwalifikowałeś/aś się', formData.zwrot_plec)}, jak teraz wygląda Twoją codzienność?`;
            default:
                return "";
        }
    }
    const selfImage = (goal) => {
        switch (goal) {
            case "Szukam pierwszej pracy":
                return `Teraz, kiedy ${convertGenderText('znalazłeś/aś', formData.zwrot_plec)} pierwszą pracę, co myślisz o sobie?`;
            case "Szukam pracy":
                return `Teraz, kiedy ${convertGenderText('znalazłeś/aś', formData.zwrot_plec)} pracę, co myślisz o sobie?`;
            case "Myślę o znalezieniu innej/nowej pracy":
                return `Teraz, kiedy ${convertGenderText('podjąłeś/łaś', formData.zwrot_plec)} decyzję o szukaniu innej pracy, co myślisz o sobie?`;
            case "Wracam na rynek pracy":
                return `Teraz, kiedy ${convertGenderText('wróciłeś/aś', formData.zwrot_plec)} na rynek pracy, co myślisz o sobie?`;
            case "Przekwalifikowuje się":
                return `Teraz, kiedy ${convertGenderText('przekwalifikowałeś/aś się', formData.zwrot_plec)}, co myślisz o sobie?`;
            default:
                return "";
        }
    }
    // Define your steps. Each step is associated with a key for the final answers.
    const steps = [
        {
            name: 'ekologia_codziennosc',
            label: everdayLife(formData.cel_wybor)
        },
        {
            name: 'ekologia_relacje',
            label: 'Jak teraz wygląda Twoje relacje z innymi?'
        },
        {
            name: 'ekologia_mysli_o_sobie',
            label: selfImage(formData.cel_wybor)
        },
        {
            name: 'ekologia_samopoczucie',
            label: 'Jak się z tym czujesz?'
        }
    ];

    // currentStep tracks which question we are on.
    const [currentStep, setCurrentStep] = useState(0);
    // answers accumulates each step’s answer keyed by the field name.
    const [answers, setAnswers] = useState({});

    const onSubmitStep = data => {
        const fieldName = steps[currentStep].name;
        const currentAnswer = data.currentAnswer;

        // Save the current answer into our answers state.
        setAnswers(prev => ({ ...prev, [fieldName]: currentAnswer }));

        if (currentStep < steps.length - 1) {
            setValue(fieldName, currentAnswer);
            // Reset the form so the next question starts empty.
            reset({ currentAnswer: '' });
            setCurrentStep(prev => prev + 1);
        } else {
            // On the final step, combine answers with the last answer and submit.
            onNext({ ...answers, [fieldName]: currentAnswer });
        }
    };

    const currentStepData = steps[currentStep];

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmitStep)} sx={{ mt: 3 }}>
            <FormLabel>
                <Typography variant="h6" color="black" gutterBottom>
                    {currentStepData.label}
                </Typography>
            </FormLabel>
            <Controller
                name="currentAnswer"
                control={control}
                rules={{ required: "To pole jest wymagane" }}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        multiline
                        rows={4}
                        error={!!errors.currentAnswer}
                        helperText={errors.currentAnswer?.message}
                        sx={{ mb: 3 }}
                    />
                )}
            />
            <Button type="submit" variant="contained" color="primary" fullWidth>
                Dalej
            </Button>
        </Box>
    );
};

export default EcologySection;
